import React, { useState } from 'react';

const FamilyPortal = () => {
  const [activeTab, setActiveTab] = useState('dashboard');

  const mockChild = {
    name: 'Jordan Smith',
    age: 16,
    sport: 'Basketball',
    level: 'Varsity',
    nextSession: 'Tomorrow, 4:00 PM',
    profileImage: 'JS'
  };

  const mockProgress = [
    { 
      metric: 'Speed (40-yard)', 
      current: '4.8s', 
      goal: '4.6s', 
      progress: 75,
      change: '-0.2s',
      trend: 'up'
    },
    { 
      metric: 'Vertical Jump', 
      current: '28"', 
      goal: '32"', 
      progress: 60,
      change: '+2"',
      trend: 'up'
    },
    { 
      metric: 'Bench Press', 
      current: '145 lbs', 
      goal: '165 lbs', 
      progress: 80,
      change: '+15 lbs',
      trend: 'up'
    }
  ];

  const mockSchedule = [
    { 
      date: 'Mon, Dec 2', 
      time: '4:00 PM', 
      session: 'Speed & Agility', 
      coach: 'Justin King',
      type: 'training',
      status: 'upcoming'
    },
    { 
      date: 'Wed, Dec 4', 
      time: '3:30 PM', 
      session: 'Strength Training', 
      coach: 'Michael Susi',
      type: 'strength',
      status: 'upcoming'
    },
    { 
      date: 'Fri, Dec 6', 
      time: '4:00 PM', 
      session: 'Recovery Session', 
      coach: 'Michael Susi',
      type: 'recovery',
      status: 'upcoming'
    }
  ];

  const mockRecentActivity = [
    { date: 'Nov 28', session: 'Speed Training', performance: 'Excellent', notes: 'New personal best in 40-yard dash' },
    { date: 'Nov 26', session: 'Strength Training', performance: 'Good', notes: 'Increased bench press by 10 lbs' },
    { date: 'Nov 24', session: 'Recovery', performance: 'Complete', notes: 'Full mobility and flexibility session' }
  ];

  const renderDashboard = () => (
    <div className="space-y-12">
      {/* Featured Athlete Image */}
      <div className="rounded-2xl overflow-hidden shadow-xl">
        <img 
          src="/assets/DTS_Warm_Up_Daniel_Farò_Photos_ID7098.jpg"
          alt="Athlete Training"
          className="w-full h-64 object-cover"
        />
        <div className="bg-gradient-to-t from-black/60 to-transparent absolute bottom-0 left-0 right-0 p-6 -mt-32">
          <h2 className="text-3xl font-light text-white mb-2">Jordan Smith</h2>
          <p className="text-white/90">Basketball • Varsity • Age 16</p>
        </div>
      </div>

      {/* Athlete Profile Card */}
      <div className="bg-white border border-gray-200 rounded-2xl p-8">
        <div className="flex items-start justify-between mb-8">
          <div className="flex items-center space-x-6">
            <div 
              className="w-20 h-20 rounded-2xl overflow-hidden"
              style={{
                backgroundImage: `url('/assets/DTS_Warm_Up_Daniel_Farò_Photos_ID7098.jpg')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }}
            />
            <div>
              <h1 className="text-3xl font-light text-gray-900 mb-1">{mockChild.name}</h1>
              <div className="flex items-center space-x-4 text-gray-600">
                <span className="font-medium">{mockChild.sport}</span>
                <span>•</span>
                <span>{mockChild.level}</span>
                <span>•</span>
                <span>Age {mockChild.age}</span>
              </div>
            </div>
          </div>
          <div className="text-right">
            <p className="text-sm font-medium text-gray-500 uppercase tracking-wide mb-1">Next Session</p>
            <p className="text-lg font-medium text-spi-600">{mockChild.nextSession}</p>
          </div>
        </div>
        
        {/* Quick Stats */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          <div className="text-center p-6 bg-gray-50 rounded-xl">
            <div className="text-3xl font-light text-spi-600 mb-2">12</div>
            <div className="text-sm font-medium text-gray-600 uppercase tracking-wide">Sessions This Month</div>
          </div>
          <div className="text-center p-6 bg-gray-50 rounded-xl">
            <div className="text-3xl font-light text-spi-600 mb-2">3</div>
            <div className="text-sm font-medium text-gray-600 uppercase tracking-wide">Goals Achieved</div>
          </div>
          <div className="text-center p-6 bg-gray-50 rounded-xl">
            <div className="text-3xl font-light text-spi-600 mb-2">85%</div>
            <div className="text-sm font-medium text-gray-600 uppercase tracking-wide">Overall Progress</div>
          </div>
          <div className="text-center p-6 bg-gray-50 rounded-xl">
            <div className="text-3xl font-light text-spi-600 mb-2">A-</div>
            <div className="text-sm font-medium text-gray-600 uppercase tracking-wide">Current Grade</div>
          </div>
        </div>
      </div>

      <div className="grid lg:grid-cols-2 gap-8">
        {/* Performance Progress */}
        <div className="bg-white border border-gray-200 rounded-2xl p-8">
          <div className="flex items-center justify-between mb-8">
            <h2 className="text-2xl font-light text-gray-900">Performance Metrics</h2>
            <button className="text-sm font-medium text-spi-600 hover:text-spi-700">View All</button>
          </div>
          <div className="space-y-8">
            {mockProgress.map((item, index) => (
              <div key={index}>
                <div className="flex items-center justify-between mb-3">
                  <div>
                    <h3 className="font-medium text-gray-900">{item.metric}</h3>
                    <div className="flex items-center space-x-2 mt-1">
                      <span className="text-sm text-gray-600">{item.current} → {item.goal}</span>
                      <span className="text-xs font-medium text-green-600 bg-green-50 px-2 py-1 rounded-full">
                        {item.change}
                      </span>
                    </div>
                  </div>
                  <div className="text-right">
                    <span className="text-2xl font-light text-spi-600">{item.progress}%</span>
                  </div>
                </div>
                <div className="w-full bg-gray-100 rounded-full h-3">
                  <div 
                    className="bg-spi-600 h-3 rounded-full transition-all duration-300" 
                    style={{ width: `${item.progress}%` }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Recent Activity */}
        <div className="bg-white border border-gray-200 rounded-2xl p-8">
          <div className="flex items-center justify-between mb-8">
            <h2 className="text-2xl font-light text-gray-900">Recent Activity</h2>
            <button className="text-sm font-medium text-spi-600 hover:text-spi-700">View All</button>
          </div>
          <div className="space-y-6">
            {mockRecentActivity.map((activity, index) => (
              <div key={index} className="border-l-4 border-spi-600 pl-6 py-2">
                <div className="flex items-start justify-between mb-2">
                  <div>
                    <h3 className="font-medium text-gray-900">{activity.session}</h3>
                    <p className="text-sm text-gray-600 mt-1">{activity.notes}</p>
                  </div>
                  <div className="text-right">
                    <div className="text-sm font-medium text-gray-900">{activity.date}</div>
                    <div className="text-xs font-medium text-green-600 bg-green-50 px-2 py-1 rounded-full mt-1">
                      {activity.performance}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Training Images Gallery */}
      <div className="bg-white border border-gray-200 rounded-2xl p-8">
        <h2 className="text-2xl font-light text-gray-900 mb-8">Recent Training Photos</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="rounded-xl overflow-hidden">
            <img 
              src="/assets/DTS_Warm_Up_Daniel_Farò_Photos_ID7067.jpg"
              alt="Training Session 1"
              className="w-full h-48 object-cover hover:scale-105 transition-transform duration-300"
            />
            <div className="p-3 bg-gray-50">
              <p className="text-sm font-medium text-gray-900">Speed Training</p>
              <p className="text-xs text-gray-600">Nov 28, 2024</p>
            </div>
          </div>
          <div className="rounded-xl overflow-hidden">
            <img 
              src="/assets/DTS_Warm_Up_Daniel_Farò_Photos_ID7100.jpg"
              alt="Training Session 2"
              className="w-full h-48 object-cover hover:scale-105 transition-transform duration-300"
            />
            <div className="p-3 bg-gray-50">
              <p className="text-sm font-medium text-gray-900">Strength Training</p>
              <p className="text-xs text-gray-600">Nov 26, 2024</p>
            </div>
          </div>
          <div className="rounded-xl overflow-hidden">
            <img 
              src="/assets/DTS_Warm_Up_Daniel_Farò_Photos_ID7104.jpg"
              alt="Training Session 3"
              className="w-full h-48 object-cover hover:scale-105 transition-transform duration-300"
            />
            <div className="p-3 bg-gray-50">
              <p className="text-sm font-medium text-gray-900">Recovery Session</p>
              <p className="text-xs text-gray-600">Nov 24, 2024</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderSchedule = () => (
    <div className="bg-white border border-gray-200 rounded-2xl p-8">
      <div className="flex items-center justify-between mb-8">
        <h2 className="text-2xl font-light text-gray-900">Training Schedule</h2>
        <div className="flex space-x-2">
          <button className="px-4 py-2 text-sm font-medium text-spi-600 bg-spi-50 rounded-lg">This Week</button>
          <button className="px-4 py-2 text-sm font-medium text-gray-600 hover:bg-gray-50 rounded-lg">Next Week</button>
        </div>
      </div>
      <div className="space-y-4">
        {mockSchedule.map((session, index) => (
          <div key={index} className="flex items-center justify-between p-6 border border-gray-200 rounded-xl hover:border-spi-200 transition-colors">
            <div className="flex items-center space-x-4">
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${
                session.type === 'training' ? 'bg-blue-100 text-blue-600' :
                session.type === 'strength' ? 'bg-red-100 text-red-600' :
                'bg-green-100 text-green-600'
              }`}>
                {session.type === 'training' ? (
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                ) : session.type === 'strength' ? (
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.5 12a7.5 7.5 0 0015 0m-15 0a7.5 7.5 0 1115 0m-15 0H3m16.5 0H21m-1.5 0H12m-8.457 3.077l1.41-.513m14.095-5.13l1.41-.513M5.106 17.785l1.15-.964m11.49-9.642l1.149-.964M7.501 19.795l.75-1.3m7.5-12.99l.75-1.3m-6.063 16.658l.26-1.477m2.605-14.772l.26-1.477m0 17.726l-.26-1.477M10.698 4.614l-.26-1.477M16.5 19.794l-.75-1.299M7.5 4.205L8.25 2.99M12 12.01h.01" />
                  </svg>
                ) : (
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                  </svg>
                )}
              </div>
              <div>
                <h3 className="font-medium text-gray-900 text-lg">{session.session}</h3>
                <p className="text-gray-600">with Coach {session.coach}</p>
              </div>
            </div>
            <div className="text-right">
              <div className="font-medium text-gray-900 text-lg">{session.date}</div>
              <div className="text-spi-600 font-medium">{session.time}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  const renderMessages = () => (
    <div className="bg-white border border-gray-200 rounded-2xl p-8">
      <div className="flex items-center justify-between mb-8">
        <h2 className="text-2xl font-light text-gray-900">Messages & Updates</h2>
        <button className="px-4 py-2 text-sm font-medium text-white bg-spi-600 hover:bg-spi-700 rounded-lg">
          New Message
        </button>
      </div>
      <div className="space-y-6">
        <div className="border-l-4 border-spi-600 pl-6 py-4 bg-spi-50 rounded-r-xl">
          <div className="flex items-start justify-between mb-3">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-spi-600 text-white rounded-lg flex items-center justify-center font-medium text-sm">
                JK
              </div>
              <div>
                <p className="font-medium text-gray-900">Coach Justin King</p>
                <p className="text-sm text-gray-600">Speed Training Coach</p>
              </div>
            </div>
            <span className="text-sm text-gray-500">2 days ago</span>
          </div>
          <p className="text-gray-800 leading-relaxed">Great improvement in Jordan's sprint times this week! The form drills are really paying off. Keep up the excellent work and let's aim for another 0.1 second improvement by next week.</p>
        </div>
        
        <div className="border-l-4 border-gray-300 pl-6 py-4 bg-gray-50 rounded-r-xl">
          <div className="flex items-start justify-between mb-3">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gray-600 text-white rounded-lg flex items-center justify-center font-medium text-sm">
                SU
              </div>
              <div>
                <p className="font-medium text-gray-900">System Update</p>
                <p className="text-sm text-gray-600">Automated Message</p>
              </div>
            </div>
            <span className="text-sm text-gray-500">1 week ago</span>
          </div>
          <p className="text-gray-800 leading-relaxed">New performance metrics have been added to your dashboard. Check the Progress tab for detailed insights into Jordan's development.</p>
        </div>

        <div className="border-l-4 border-green-500 pl-6 py-4 bg-green-50 rounded-r-xl">
          <div className="flex items-start justify-between mb-3">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-green-600 text-white rounded-lg flex items-center justify-center font-medium text-sm">
                MS
              </div>
              <div>
                <p className="font-medium text-gray-900">Coach Michael Susi</p>
                <p className="text-sm text-gray-600">Recovery Specialist</p>
              </div>
            </div>
            <span className="text-sm text-gray-500">1 week ago</span>
          </div>
          <p className="text-gray-800 leading-relaxed">Jordan showed excellent dedication during recovery sessions. The mobility improvements are significant and will support better performance in training.</p>
        </div>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-light text-gray-900">Family Portal</h1>
              <p className="text-gray-600 mt-1">Track your athlete's progress and stay connected with coaches</p>
            </div>
            <div className="flex items-center space-x-4">
              <button className="px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-900 border border-gray-300 rounded-lg hover:bg-gray-50">
                Settings
              </button>
              <button className="px-4 py-2 text-sm font-medium text-white bg-spi-600 hover:bg-spi-700 rounded-lg">
                Contact Support
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="flex space-x-12">
            {[
              { key: 'dashboard', label: 'Dashboard', icon: '📊' },
              { key: 'schedule', label: 'Schedule', icon: '📅' },
              { key: 'messages', label: 'Messages', icon: '💬' }
            ].map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={`flex items-center space-x-2 py-4 border-b-2 font-medium text-sm transition-colors ${
                  activeTab === tab.key
                    ? 'border-spi-600 text-spi-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <span className="text-base">{tab.icon}</span>
                <span>{tab.label}</span>
              </button>
            ))}
          </nav>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {activeTab === 'dashboard' && renderDashboard()}
        {activeTab === 'schedule' && renderSchedule()}
        {activeTab === 'messages' && renderMessages()}
      </div>
    </div>
  );
};

export default FamilyPortal;